export default function ({ route, error }) {
  if (route.path === '/banks' || route.path === '/buyout') {
    return error({ statusCode: 404, message: 'Page not found' })
  }
}